export default "__VITE_ASSET__BHlYxEUj__"